import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData1 from "../animation-data/twinkling-stars/twinkling_star1.json";
import animationData2 from "../animation-data/twinkling-stars/twinkling_star2.json";

function TwinklingStarAnimation({containerId="twinkling-star-animation", type}) {

  const animationData = type && type == 2 ? animationData2 : animationData1;

  useEffect(() => {
    lottie.loadAnimation({
      container: document.getElementById(containerId),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData,
      progressiveLoad: true,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    });
  },[])

  return (
    <div id={containerId}></div>
  )
}

export default TwinklingStarAnimation;